import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {FlexLayoutModule} from '@angular/flex-layout';
import {LoginComponent} from "./login/login.component";
import {ForgotPasswordComponent} from "./password-manager/forgot-password/forgot-password.component";
import {PasswordStrengthComponent} from "./password-manager/password-strength/password-strength.component";
import {ResetPasswordRequiredComponent} from "./password-manager/reset-password-required/reset-password-required.component";
import {ConfirmEmailComponent} from "./password-manager/confirm-email/confirm-email.component";
import {AuthLibraryModule, PasswordManagerModule} from "@symbiotics/auth-library";
import {RegisterComponent} from "./register/register.component";
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {path: 'forgot-password', component: ForgotPasswordComponent},
  {path: 'register', component: RegisterComponent},
  {path: 'confirm/:user', component: ConfirmEmailComponent},
  {path: 'reset-password/:user', component: ResetPasswordRequiredComponent},
]

@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    RegisterComponent,
    PasswordStrengthComponent,
    ResetPasswordRequiredComponent,
    ConfirmEmailComponent
  ],
  imports: [
    CommonModule,
    AuthLibraryModule,
    HttpClientModule,
    FlexLayoutModule,
    PasswordManagerModule,
    RouterModule.forChild(routes),
    AuthLibraryModule, PasswordManagerModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [LoginComponent,
    ForgotPasswordComponent,
    PasswordStrengthComponent,
    ConfirmEmailComponent,
    ResetPasswordRequiredComponent]
})
export class AuthModule {
}
